<template>
	<div>
		<div class="title-container">
			<div class="title">Edit Product</div>
			<div class="buttons">
				<router-link to="/commerce/products/list" class="button"><div class="hover-title">Cancel</div><span class="fa fa-times"></span></router-link>
			</div>
		</div>

		<product-form
			v-if="form.id"
			v-model="form" :original-form="originalForm"
			:server-errors="errors"
			:categories="categories"
			:module-data="moduleData"
			@saved="onSaved">
		</product-form>
	</div>
</template>

<script>

import FormMixin from '@/mixins/FormMixin';
import ProductForm from './forms/ProductForm';

export default {

	name: 'ProductsEditPage',

	mixins: [FormMixin],

	async asyncData({ app, route }) {
		const { data } = await app.$api.get(`/commerce/products/${ route.params.id }/edit`);

		const { product, categories, ...moduleData } = data;

		product.variants = product.variants.map(variant => {
			if (variant.is_default) {
				product.default_variant_id = variant.id;
			}

			variant.groups = variant.groups.reduce((carry, group) => {
				carry[group.id] = group.pivot.name;
				return carry;
			}, {});

			return variant;
		});

		product.categories = product.categories.map(category => category.id + '');

		product.files = product.photos.map(photo => {
			return {
				...photo,
				variant_id: photo.variant_id || 0,
				src: photo.filepath + '500.' + photo.filename,
				largeSrc: photo.filepath + '3000.' + photo.filename,
			};
		});

		delete product.photos;

		moduleData.module.fields.forEach(field => {
			if (field.type === 'associated_module') {
				product[ field.slug ] = (product[ field.slug ] || []).map(tag => tag.id + '');
			}
		});

		return {
			form: product,
			originalForm: JSON.parse(JSON.stringify(product)),
			categories: data.categories,
			moduleData,
		};
	},

	data() {
		return {
			categories: [],
			moduleData: {},
			form: {},
			originalForm: {},
			leaving: false,
		};
	},

	computed: {

		hasFormChanged() {
			return JSON.stringify(this.form) !== JSON.stringify(this.originalForm);
		},

	},

	beforeRouteLeave(to, from, next) {
		if (!this.leaving && this.hasFormChanged && !window.confirm('You have unsaved changes, are you sure you want to leave?')) {
			return next(false);
		}

		next();
	},

	methods: {

		onSaved() {
			this.$store.dispatch('addToast', 'Product Updated');
			this.leaving = true;
			this.$router.push('/commerce/products/list');
		},

	},

	components: {
		ProductForm,
	},

};

</script>
